import React, { useState } from "react";
import api, { setToken } from "../api";
import { useNavigate } from "react-router-dom";

export default function Login({ setUser }) {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      const res = await api.post('/login', { email, password });

      const { token, user } = res.data;

      localStorage.setItem('token', token);
      setToken(token);
      setUser(user);

      nav('/');

    } catch (err) {
      alert(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid vh-100 d-flex align-items-center justify-content-center px-2">

      <div className="card shadow p-3 w-100" style={{ maxWidth: "400px" }}>

        <h4 className="text-center mb-3">🔐 Login</h4>

        <form onSubmit={submit}>

          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              className="form-control"
              value={email}
              onChange={e => setEmail(e.target.value)}
              type="email"
              placeholder="Enter email"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Password</label>
            <input
              className="form-control"
              value={password}
              onChange={e => setPassword(e.target.value)}
              type="password"
              placeholder="Enter password"
              required
            />
          </div>

          <button
            className="btn btn-primary w-100"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>

        </form>

      </div>

    </div>
  );
}